import MasterTab from 'src/components/Layouts/MasterTab.vue';
import Security from "src/views/Pages/Dashboard/Grow/Reports/Security/Security.vue";
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';

const SecurityRoutes = {
    path: 'grow',
    name: 'grow.grow',
    component: MasterTab,
    props: { reference: 'growTabs' },
    children: [
        {
            path: 'securityreport',
            component: EmptyRouterView,
            children: [
                {
                    path: '',
                    name: 'grow.security_report',
                    component: Security,
                    meta: {
                        path: 'securityreport',
                        prefix_permission: 'grow_securityreport',
                    },
                },
            ],
        },
    ],
};

export default SecurityRoutes;